import React from 'react';

function TopTitle({title}){
    const style = {
        fontSize:'22px'
    }
    return (
        <h2 className="text-center font-weight-bold mt-5 mb-5" style={style}>{title}</h2>
    )
}

export default TopTitle;